import React from 'react';

import type { NewsletterConfig } from './types.js';

import { LinkWithPulse } from '../../../../core/mandatory-integrations/pulse/components/LinkWithPulse.js';
import { getAccess } from './LoggedIn.js';

interface NotLoggedInProps extends NewsletterConfig {
  location: string;
}

export const NotLoggedIn: React.FC<NotLoggedInProps> = ({
  title,
  description,
  location,
  access,
}) => (
  <div className="newsletter-container">
    <div className="newsletter-title">{title}</div>
    <div className="newsletter-description-texts">
      <p>{description}</p>
    </div>
    <div className="newsletter-footer">
      {getAccess(access)}
      <LinkWithPulse
        className="toggle-switch"
        href={location}
        id="newsletter:not-logged-on"
        name="Link to newsletter portal for logged out"
        ariaLabel="til nyhetsbrev portal"
      >
        <span className="toggle-switch-slider"></span>
      </LinkWithPulse>
    </div>
  </div>
);
